import PropTypes from 'prop-types'

/* types */
import { languageShape } from '../../types/languageShape'
import { avatarShape } from '../../types/avatarShape'

export const propTypesUser = {
  language: PropTypes.shape(languageShape),
  avatar: PropTypes.shape(avatarShape),
  email: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  first_name: PropTypes.string.isRequired,
  last_name: PropTypes.string.isRequired,
  profile_filled: PropTypes.bool.isRequired,
  twaming_account: PropTypes.bool.isRequired,
}

export const propsDefaultUser = {
  avatar: [],
}
